<template>
    <!-- 配置-抽成配置-司机抽成 -->
    <!-- 模式一单独组件，也就是父组件，模式二和创单抽成共用组件，也就是子组件
    模式一单独保存，模式二和创单抽成在子组件保存数据根据当前激活tab页传参来决定提交接口和提交数据；详情赋值后需要把使用中状态传给父组件，因为使用中状态是在父组件判断
    模式一父组件切换tab标签需要调详情接口完成后，重新给激活标签赋值，才能正确切换到要去的标签页，否则会因为异步导致激活状态被详情接口覆盖而切换不过去 -->
    <div class="container pay">
        <div class="title">
            <h2>司机抽成配置</h2>
            <span>配置每笔订单抽取司机的金额，固定金额抽成和百分百抽成可同时生效</span>
        </div>

        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="模式一" name="1">
                <span slot="label"> <el-tag type="success" v-if="modeChange == 1">使用中</el-tag> 模式一 </span>
                <!-- 模式一 -->
                <div class="mode-name">
                    <!-- 说明文字 -->
                    <span class="mode-title">
                        原有收费模式全职司机每单不收费、兼职司机每单收取固定费用，钱收入到各个子公司及加盟商，支付方式为微信、支付宝和银行卡。不可自动提现
                    </span>

                    <!-- 提交数据 -->
                    <div>
                        <span style="font-weight: 700">司机抽成：</span>
                        <span>配置每笔订单抽取司机的金额</span>
                        <div class="full-driver">全职司机 : <span style="margin-left: 50px">不抽成</span></div>
                        <span style="margin-top: 10px; margin-left: 70px"
                            >兼职司机 :<el-input
                                disabled
                                v-model="driver_insurance"
                                style="padding-left: 55px; margin-top: 10px"
                                class="input-item1"
                            >
                            </el-input>
                            元</span
                        >
                        <div style="margin-top: 10px; margin-left: 70px; margin-bottom: 30px">
                            原配置微调中的{司机服务费}，从司机服务费账户扣除
                        </div>
                    </div>
                    <!-- 保存按钮 如果当前模式是生效中则不展示保存按钮，空闲中的才展示保存按钮-->
                    <el-button class="sava-btn" @click="onSubmitDig('1')" type="primary" :disabled="saveLoading" v-loading="saveLoading">{{
                        saveLoading == true ? '保存数据中...' : '保存并使用'
                    }}</el-button>
                </div>
            </el-tab-pane>
            <el-tab-pane label="模式二" name="2">
                <span slot="label">模式二<el-tag type="success" v-if="modeChange == 2">使用中</el-tag></span>
            </el-tab-pane>
            <el-tab-pane label="阶梯抽成" name="4">
                <span slot="label">阶梯抽成<el-tag type="success" v-if="modeChange == 4">使用中</el-tag></span>

            </el-tab-pane>
            <el-tab-pane label="创单抽成配置" name="3">
                <span slot="label">创单抽成配置<el-tag type="success" v-if="awaitPayMode_status == 1">使用中</el-tag></span>
                <!-- 创单抽成配置 -->
            </el-tab-pane>

        </el-tabs>
        <!-- <div style="margin-top: 20px" v-if="activeName == '3'">
            是否开启
            <el-switch v-model="awaitStatus" active-value="1" inactive-value="0"> </el-switch>

            创单抽成启用后，司机不在遵循模式一或模式二抽成规则，非创单依旧遵循
        </div> -->

        <!-- v-show 通过css隐藏dom节点 导致从其他模块切换到该模块后，不走子组件的created事件，无法给模式二赋值，导致模式二为使用中的时候不展示数据 -->
        <!-- <modeTwo ref="childRef" v-show="activeName == '2' || activeName == '3'" :activeName="activeName" @updateUseMode="updateUseMode">
        </modeTwo> -->
        <!-- v-if 直接删除dom节点,模式二切换到模式一会走子组件created里面的方法，如果方法没走完，又快速切换到模式二，导致上个没走完的方法继续走，新的方法又开始走，就出现了数据不对的问题，
        所以要保证从模式二切换到模式一的时候，子组件里面的方法走完在切换到模式二，或者从模式二切换到模式一的时候，不走子组件created方法去赋值 -->
        <modeTwo ref="childRef" v-if="activeName == '2' || activeName == '3'" :activeName="activeName" @updateUseMode="updateUseMode">
        </modeTwo>


        <payModeThird ref="childRef" v-if="activeName == '4'" :activeName="activeName" @updateUseMode="updateUseMode">
        </payModeThird>

    </div>
</template>

<script>
var _this;
import bus from '@/components/common/bus';
import payModeThird from './payModeThird.vue';
import modeTwo from './modeTwo.vue';
export default {
    components: {
        // editMode,
        modeTwo,
        payModeThird
    },
    data() {
        return {
            // awaitStatus:'',//子组件保存会把提交数据传到父组件会覆盖status,所以需要重新赋值

            saveLoading: false, // 保存数据loading
            changeIndex: '', // 订单模式编辑按钮点击的index
            checkboxSelect: '', // 编辑订单模式共用一个组件，用于区分全职，兼职，按单
            awaitPayMode_status: '0', // 创单抽成配置使用中状态判断

            // 获取订单模式查询条件
            mode_options_data: {
                page: 1,
                limit: 50,
                status: ''
            },
            modeAll: [], // 获取订单模式后 订单模式编码
            allModeArr: [], // 获取订单模式后 订单模式数组

            editMode_show: false, // 编辑组件
            modeTwo_show: true, // 模式二组件

            loading: false,

            full_synchronization: [], // 全职抽成生效时间段
            part_synchronization: [], // 兼职抽成生效时间段
            single_synchronization: [], // 按单抽成生效时间段

            selectTimeQ: false,
            selectTimeJ: false,
            selectTimeD: false,

            // tab标签当前选中项
            activeName: '1',
            modeChange: '', // 使用中状态判断
            driver_insurance: '', // 模式一 兼职司机v-model绑定值

            submit_url: '/paymode/editpayModeSub',

            // 表单数据
            submit_data: {
                status: '', // 创单抽成配置 是否开启的开关
                two_full_money: '0', //默认值为0，没有也要填0才能保存 全职固定金额
                two_full_rate: '0', //默认值为0，没有也要填0才能保存 全职百分比金额抽成
                two_part_money: '0', //默认值为0，没有也要填0才能保存 兼职固定金额
                two_part_rate: '0', //默认值为0，没有也要填0才能保存 兼职百分比金额抽成
                two_single_money: '0', //默认值为0，没有也要填0才能保存 按单固定金额
                two_single_rate: '0', //默认值为0，没有也要填0才能保存 按单百分比金额抽成
                use_mode: '', // 模式一或者模式二使用中标识
                full_synchronization: '', // 全职自定义时间段抽成
                part_synchronization: '', // 兼职自定义时间段抽成
                single_synchronization: '' // 按单自定义时间段抽成
            },

            submit_rules: {
                two_full_money: {
                    placeholder: '全职司机固定金额抽成',
                    rules: {
                        required: false,
                        message: '全职司机固定金额抽成为大于等于0的数字',
                        regulation: 'egt',
                        rulesData: '0'
                    }
                },

                two_full_rate: {
                    placeholder: '全职司机订单金额百分比抽成',
                    rules: {
                        required: false,
                        message: '全职司机订单金额百分比抽成为大于等于0的数字',
                        regulation: 'between',
                        rulesData: [0, 9999]
                    }
                },

                two_part_money: {
                    placeholder: '兼职司机固定金额抽成',
                    rules: {
                        required: false,
                        message: '兼职司机固定金额抽成为大于等于0的数字',
                        regulation: 'egt',
                        rulesData: '0'
                    }
                },

                two_part_rate: {
                    placeholder: '兼职司机订单金额百分比抽成',
                    rules: {
                        required: false,
                        message: '兼职司机订单金额百分比抽成为大于等于0的数字',
                        regulation: 'between',
                        rulesData: [0, 9999]
                    }
                },
                two_single_money: {
                    placeholder: '按单司机固定金额抽成',
                    rules: {
                        required: false,
                        message: '按单司机固定金额抽成为大于等于0的数字',
                        regulation: 'egt',
                        rulesData: '0'
                    }
                },

                two_single_rate: {
                    placeholder: '按单司机订单金额百分比抽成',
                    rules: {
                        required: false,
                        message: '按单司机订单金额百分比抽成为大于等于0的数字',
                        regulation: 'between',
                        rulesData: [0, 9999]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.payModeList(); // 获取司机抽成配置
        _this.awaitPayMode(); // 获取创单抽成配置
    },

    methods: {
        // 子组件自定义事件
        updateUseMode(val, mode) {
            if (mode == '2' || mode == '4') {
                // 如果子组件修改了模式二为使用中，则需要通过父组件更新使用中状态
                _this.modeChange = val;
            }
            if (mode == '3') {
                // 如果子组件修改了创单抽成配置是否开启开关状态，则需要通过父组件更新创单抽成使用中状态

                _this.awaitPayMode_status = val;
            }
        },

        // tab选项卡点击事件
        async handleClick(tab, event) {
            // _this.loading = true;
            this.$nextTick(() => {
                // console.log(this.$refs.childRef, '_this.$refs.childRef???有时候是undefined'，放到this.$nextTick里面就好了);
            });

            if (tab.name == '2') {
                // 修改子组件的激活状态
                // this.$refs.childRef.activeName_children = '2';
                // console.log(this.$refs.childRef.activeName_children, 'this.$refs.childRef.activeName_children');
                _this.$nextTick(async () => {
                    await _this.$refs.childRef.payModeList(); // $refs调用子组件方法，this.$nextTick 防止this.$refs.childRef是undefined，切换标签要走详情接口重新赋值
                    // 模式二和创单抽成配置共用一个组件和相同的变量，所以切换标签必须重新调接口重新赋值
                });

                // await _this.$refs.childRef.payModeList();

                //触发子组件执行方法刷新列表数据

                // await _this.payModeList(); // 切换tab页的时候调接口赋值，赋值后重新确定激活选项卡
                _this.activeName = '2'; // 接口赋值的时候把tab激活选项卡赋值了，使用中的为激活，但是切换tab栏的时候需要把新点击的赋值成激活项
                // console.log(_this.activeName, '_this.activeName222');
            } else if (tab.name == '1') {
                // await _this.$refs.childRef.payModeList();
                // 修改子组件的激活状态
                // this.$refs.childRef.activeName_children = '1';
                // _this.activeName = '1';
                await _this.payModeList('noTab');
                _this.activeName = '1';

                // console.log(_this.activeName, '_this.activeName');
            } else if (tab.name == '3') {
                // 修改子组件的激活状态
                // this.$refs.childRef.activeName_children = '3';
                this.$nextTick(async () => {
                    await _this.$refs.childRef.awaitPayMode();
                });
                // await _this.$refs.childRef.awaitPayMode();

                // await _this.awaitPayMode();
                _this.activeName = '3';
            }else if (tab.name == '4') {

                _this.activeName = '4';
            }
            // this.$refs.childRef.activeName_children = _this.activeName;// 不写这行导致从创单抽成切换到模式二的时候不展示保存按钮

            // console.log(_this.$refs.childRef.activeName_children, '切换tab子组件activeName_children值');
        },
        // 列表
        payModeList(val) {
            return new Promise((resolve) => {
                _this
                    .$post('/paymode/payModeList')
                    .then((res) => {
                        if (val != 'noTab') {

                            // noTab参数用来区分这个接口是不是点击tab标签的时候调用的
                            _this.activeName = res.data.use_mode; // 模式一模式二tab标签激活状态，使用中的tab页激活显示
                        }
                        // _this.activeName = res.data.use_mode; // 模式一模式二tab标签激活状态，使用中的tab页激活显示,上面代码注释后，切换到模式一就走子组件created代码，如果当前行注释，上面代码打开，切换到模式一，就不走created方法

                        _this.modeChange = res.data.use_mode; // 使用中状态判断,返回值为1则模式一为使用中，返回值为2则模式二为使用中
                        _this.driver_insurance = res.data.driver_insurance; //模式一 兼职司机v-model绑定值
                        _this.submit_data.use_mode = res.data.use_mode; // 使用中状态的提交值
                        // 当前页面并未用到下面的数据，但是接口需要submit_data.full_synchronization是转成的JSON字符串
                        _this.submit_data.full_synchronization = res.data.full_synchronization;
                        _this.submit_data.part_synchronization = res.data.part_synchronization;
                        _this.submit_data.single_synchronization = res.data.single_synchronization;
                        _this.submit_data.two_full_money = res.data.two_full_money; // 全职司机固定金额抽成
                        _this.submit_data.two_full_rate = res.data.two_full_rate; // 全职司机订单金额百分比抽成
                        _this.submit_data.two_part_money = res.data.two_part_money; // 兼职司机固定金额抽成
                        _this.submit_data.two_part_rate = res.data.two_part_rate; // 兼职司机订单金额百分比抽成
                        _this.submit_data.two_single_money = res.data.two_single_money; // 按单司机固定金额抽成
                        _this.submit_data.two_single_rate = res.data.two_single_rate; // 按单司机订单金额百分比抽成

                        // console.log(_this.part_synchronization[0].part_order_mode_code_array.length, 'part_order_mode_code_array'); // 这行代码导致下面代码不执行，因为接口返回空数组的时候，这回代码就无法打印了

                        // console.log('父组件payModeList赋值完成');

                        resolve();
                    })
                    .catch((err) => {});
            });
        },

        // 获取创单抽成配置
        awaitPayMode() {
            _this
                .$post('/paymode/awaitPayMode')
                .then((res) => {
                    _this.awaitPayMode_status = res.data.status;
                    resolve();
                    // console.log('父组件创单抽成使用中状态赋值完成');
                    // _this.loading = false;
                })
                .catch((err) => {});
        },

        // 提交

        onSubmitDig(e) {
            // console.log(_this.submit_data, '提交数据');
            // e = 1代表模式一，e = 2代表模式二，哪个模式点击保存按钮，哪个模式就是使用中状态
            _this.submit_data.use_mode = e;

            _this.saveLoading = true;

            // console.log(_this.submit_data, '_this.submit_data');
            bus.$on('btnStatus', (val) => {
                _this.saveLoading = val;
                // 接收http.js if (rules !== {}) {}里面的bus.$emit('btnStatus', false)，验证不通过，取消按钮loading
            });

            _this
                .$post(_this.submit_url, _this.submit_data, _this.submit_rules)
                .then((res) => {
                    _this.saveLoading = false;

                    _this.$message.success('保存成功');
                    _this.payModeList();
                })
                .catch(() => {
                    _this.saveLoading = false;

                    this.$message(res.msg);
                });
        }
    }
};
</script>

<style scoped>
.edit-btn {
    float: right;
}

.modeStyle {
    margin-top: 10px;
}

.modeStyle > div > div {
    margin-left: 30px;
    margin-top: 10px;
    max-width: 100%;
}

.second-main-wrap {
    display: flex;
    justify-content: space-around;
}

.title h2 {
    font-weight: 700;
    margin-bottom: 30px;
    margin-right: 10px;
    color: #000;
    font-size: 24px;
    display: inline-block;
}

.title span {
    font-size: 16px;
    color: #606266;
}

.btn1 {
    margin-left: 10px;
    margin-top: 10px;
    width: 130px;
}

.timeX {
    width: 150px;
    margin-left: 10px;
    /* margin-top: 10px; */
}

.full-driver {
    margin-top: 20px;
    margin-left: 70px;
    margin-right: 10px;
}

.use_mode-btn {
    margin-left: 20px;
    height: 30px;
}

.mode-head {
    display: flex;
    align-items: center;
    margin-top: 30px;
}

.mode-title {
    display: inline-block;
    margin-bottom: 20px;
}

.mode_submit-data {
    margin: 20px 0 30px;
    width: 32%;
}

.mode-name {
    width: 500px;
    margin: 20px auto 0;
}

.modea {
    display: flex;
    justify-content: space-between;
}

.line {
    background-color: #909399;
    width: 1px;
}

.sava-btn {
    margin: 0 auto;
    display: block;
    margin-top: 10px;
}

.input-item1 {
    max-width: 160px !important;
    width: 60% !important;
    box-sizing: content-box !important;
}

.input-item-active {
    padding-left: 10px;
}

.title-square {
    background-color: #409eff;
    display: inline-block;
    width: 10px;
    height: 30px;
    margin-right: 5px;
}

.title-a {
    margin-top: 15px;
    display: inline-block;
}

.box-content {
    background-color: #eee;
    padding: 10px;
    border-radius: 10px;
    margin-bottom: 20px;
    width: 100%;
    box-sizing: border-box;
}

.span-mode {
    display: inline-block;
    width: 110px;
    text-align: right;
}

.disTitle {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

.btnTitle {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
}

.btnSelect {
    width: 50px;
    height: 40px;
    margin-bottom: 15px;
}
</style>
